import type { IconNode } from '../types';

/**
 * @name diaper
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiA5aDQiIC8+CiAgPHBhdGggZD0iTTIyIDloLTQiIC8+CiAgPHBhdGggZD0iTTkgMjBhNyA3IDAgMCAxLTctN1Y3YTIgMiAwIDAgMSAyLTJoMTZhMiAyIDAgMCAxIDIgMnY2YTcgNyAwIDAgMS03IDdaIiAvPgogIDxwYXRoIGQ9Ik0yIDEzYTcgNyAwIDAgMSA3IDciIC8+CiAgPHBhdGggZD0iTTE1IDIwYTcgNyAwIDAgMSA3LTciIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/diaper
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const diaper: IconNode = [
  ['path', { d: 'M2 9h4', key: 'lurubk' }],
  ['path', { d: 'M22 9h-4', key: '1luja7' }],
  [
    'path',
    { d: 'M9 20a7 7 0 0 1-7-7V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v6a7 7 0 0 1-7 7Z', key: 'yafqt4' },
  ],
  ['path', { d: 'M2 13a7 7 0 0 1 7 7', key: '12eahy' }],
  ['path', { d: 'M15 20a7 7 0 0 1 7-7', key: 'lklprg' }],
];

export default diaper;
